import React, { useState } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import Layout from "./Layout";
// import Error from "../pages/error";
import Login from "../pages/login";
import {
  useUserDispatch,
  useUserState,
  verifytoken,
} from "../context/UserContext";
import { useEffect } from "react";

export default function App() {
  var userDispatch = useUserDispatch();
  const { isAuthenticated, user, token, is_varify } = useUserState();

  const [isQrScan, setIsQrScan] = useState(false)
  const [message, setMessage] = useState(null);

  useEffect(() => {
    verifytoken(userDispatch);
  }, [userDispatch]);

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
        <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        />
        <PrivateRoute
          path="/app"
          token={token}
          user={user}
          component={Layout}
        />
        <PublicRoute path="/login" component={Login} />
        {/* <Route component={Error} /> */}
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, user, token, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated
            ? React.createElement(component, { ...props, user, token,  message, setMessage, setIsQrScan, isQrScan })
            : is_varify && (
                <Redirect
                  to={{
                    pathname: "/login",
                    state: {
                      from: props.location,
                    },
                  }}
                />
              )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
